import { useEffect } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { emailParts, onHoldSentence, ON_HOLD_TOAST } from '@/lib/accountOnHold';

/** A message as it came, each email address in it a mailto link (lib/accountOnHold.js emailParts). */
export function TextWithEmailLinks({ text, linkClassName = 'underline underline-offset-2' }) {
  return (
    <>
      {emailParts(text).map((p, i) => (p.email
        ? <a key={i} href={`mailto:${p.email}`} className={`tap-auto ${linkClassName}`} data-testid="email-link">{p.email}</a>
        : <span key={i}>{p.text}</span>))}
    </>
  );
}

/**
 * An account on hold, on whatever page it already has open (Ryan, 2026-10-07). Its session is refused on every request
 * (backend app/auth), and most screens fail quietly or say something of their own, so the first refused request shows
 * the server's sentence here, once per tab, until it is closed. Mounted once beside VersionWatch. Not the sign-in
 * request: the sign-in page says it in its own panel.
 */
export function AccountOnHoldNotice() {
  useEffect(() => {
    const id = api.interceptors.response.use(undefined, (err) => {
      const sentence = onHoldSentence(err);
      if (sentence && !err.config?.url?.includes('/auth/login')) {
        toast.error(<span data-testid="account-on-hold-notice"><TextWithEmailLinks text={sentence} /></span>,
          { id: ON_HOLD_TOAST, duration: Infinity });
      }
      return Promise.reject(err);
    });
    return () => api.interceptors.response.eject(id);
  }, []);
  return null;
}
